<template>
    <div
        class="md-form layout5 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
    >
        <div class="md-form-container" :class="{ 'f-col': !fullColumn }" :style="{ 'padding-bottom': paddingBtm + 'px' }">
            <div class="info-left">
                <site-title
                    v-if="title"
                    :title="title"
                    align="left"
                />
            </div>
            <div class="info-right">
                <info-form-v2
                    :registerRole="registerRole"
                    :tag="tag"
                    :questionnaire="questionnaire"
                    :onSubmitOption="onSubmitOption"
                    :formList="formList"
                    :showTitle="false"
                    :lenderStyle="{
                        background: inputBgColor
                    }"
                    :defaultMsg="defaultMsg"
                    :submitText="''"
                    :icon="'icon-send_03'"
                    :submitStyle="{
                        color: submitBgColor
                    }"
                    :registerLogin="registerLogin"
                    @done="handleShowToast"
                    @disclaimerContainerMount="disclaimerContainerMount"
                    :disclaimerColor="colorMap?.text || '#a0a3af'"
                />
            </div>
            <form-toast
                v-model:visible="formToastVisible"
                v-bind="formToastOption"
                @confirm="handleToastConfirm"
            />
        </div>
    </div>
</template>

<script>
import common from '../index';
import infoFormV2 from '../info-form-v2.vue';
import formToast from '@/components/form-toast';

export default {
    mixins: [common],
    data() {
        return {
            paddingBtm: 120
        };
    },
    components: {
        infoFormV2,
        formToast
    },
    methods: {
        disclaimerContainerMount(domHeight) {
            if (this.isMobileSize) {
                this.paddingBtm = 0
            } else {
                this.paddingBtm = domHeight || 0
            }
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.layout5 {
    .md-form-container {
        display: flex;
        justify-content: space-between;
        column-gap: 50px;
        position: relative;
    }
    .info-left {
        flex: 1;
        .site-title {
            font-weight: 700;
            white-space: nowrap;
            line-height: 1;
        }
    }

    .info-right {
        width: 560px;

        .basic-info {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 30px;
            .basic-info-input {
                width: 100%;
                &.question,
                &[class*='paragraphText'] {
                    height: 100px;
                    textarea {
                        box-shadow: none;
                        width: 100%;
                        height: 100px;
                        padding: 10px 15px;
                        color: var(--g-primary-color);
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 21px;
                        text-align: left;
                    }
                }
                &:last-child {
                    margin-bottom: 0;
                    input {
                        padding-right: 50px;
                    }
                }
            }
            .chime-datepicker {
                input {
                    padding-left: 35px;
                    border-radius: 0;
                }
                .date-picker-input-wrapper i.iconfont {
                    top: 4px;
                }
            }
        }
        .basic-info-input input,
        .basic-info-input .submit {
            width: 100%;
            height: 50px;
            box-shadow: none;
            padding: 0px 20px;
            background: transparent;
            color: var(--g-primary-color);
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            text-align: left;
        }

        .basic-info-input .input-container .label-top {
            display: none;
        }

        .info-form2 .basic-info-input input,
        .info-form2 .basic-info-input textarea {
            border: none;
            border-bottom: 1px solid var(--g-primary-color);
            background: rgba(218, 218, 218, 0.15);
            &:focus {
                border-bottom: 1px solid var(--g-btn-background);
            }
        }

        .submit-content {
            position: relative;
            top: -35px;
            left: calc(100% - 35px);
            width: 20px;
            height: 20px;
            margin-bottom: 30px;
            .submit-box {
                width: 100%;
                height: 100%;
                cursor: pointer;
                &:hover {
                    opacity: 0.8;
                }
                &:hover::after {
                    content: none;
                }
                .submit-icon {
                    background: none;
                    border: none;
                    padding: 0;
                    color: var(--g-btn-background);
                }
                .iconfont {
                    font-size: 20px;
                    color: var(--g-btn-background);
                }

                &.submit-disabled {
                    cursor: not-allowed;
                    opacity: 0.4;
                }
            }
        }

        .disclaimer-wrap.opt-in {
            margin-top: 0;
            color: var(--g-tip-color);
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            .disclaimer-item {
                &:nth-child(1) {
                    margin-top: 0;
                }
            }
            .disclaimer-content,
            .privacy-text {
                color: var(--g-tip-color);
            }
            .privacy-text::before {
                margin: 30px 0;
                background: rgba(218, 218, 218, 0.5);
            }
        }
    }

    @include media-600 {
        .md-form-container {
            padding-bottom: 0;
        }

        .md-form-container {
            display: block;
        }
        .info-left {
            width: 100%;
            .site-title {
                margin-bottom: 20px;
            }
        }

        .info-right {
            width: 100%;

            .basic-info {
                gap: 0;
                .basic-info-input {
                    margin-bottom: 20px;
                }
            }

            .submit-content {
                margin-bottom: 5px;
            }

            .disclaimer-wrap.opt-in {
                position: static;

                .privacy-text::before {
                    margin: 20px 0;
                }
            }
        }
    }
}
</style>
